// :cow: Cosmose CONFIDENTIAL :iso:
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

marker('ONE_WEEK');
marker('FOUR_WEEKS');
marker('TWELVE_WEEKS');
marker('LAST_THREE_MONTHS');
marker('LAST_WEEK');
marker('LAST_FOUR_WEEKS');
marker('LAST_TWELVE_WEEKS');

export enum DateRangeFilter {
  ONE_WEEK = 'ONE_WEEK',
  FOUR_WEEKS = 'FOUR_WEEKS',
  TWELVE_WEEKS = 'TWELVE_WEEKS',
  LAST_THREE_MONTHS = 'LAST_THREE_MONTHS',
  LAST_WEEK = 'LAST_WEEK',
  LAST_FOUR_WEEKS = 'LAST_FOUR_WEEKS',
  LAST_TWELVE_WEEKS = 'LAST_TWELVE_WEEKS'
}

export enum ClientDateAggregationType {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}
